export const VersionDetailH5Routing = {
  path: "/versionDetailH5",
  name: "versionDetailH5",
  meta: { title: "工程企业管理系统" },
  component: () =>
    import(/* webpackChunkName: "versionDetailH5" */ "@/views/join/h5/version-detail/index.vue"),
  children: [],
};
export const MiniatureVersionDetailH5Routing = {
  path: "/miniatureVersionDetailH5",
  name: "miniatureVersionDetailH5",
  meta: { title: "工程企业管理系统" },
  component: () =>
    import(/* webpackChunkName: "versionDetailH5" */ "@/views/join/h5/version-detail/miniature.vue"),
  children: [],
};